import api from './axios'

const getScannerEvents = () => api('user/isScanner', 'GET')

export default {
  getScannerEvents,
}
